export default __webpack_public_path__ + "static/media/price.048c9eb7.svg";